<template>
  <div>
    <FormulateInput
      v-if="isDisplayValue"
      type="url"
      :id="control.id"
      :name="control.name"
      :placeholder="control.placeholder"
      :help="control.help"
      :label="control.label"
      :value="control.value"
      :required="control.required"
    />
    <FormulateInput
      v-else
      type="url"
      :id="control.id"
      :name="control.name"
      :placeholder="control.placeholder"
      :help="control.help"
      :label="control.label"
    />
  </div>
</template>

<script>
export default {
  props: {
    control: {
      type: Object,
      default: () => {}
    },
    isDisplayValue: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    isChecked() {
      console.log('test')
    }
  }
}
</script>
